import { Line } from 'react-chartjs-2';
import { Box, Loader } from '@mantine/core';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useLicenseStats } from '../hooks/useLicenseStats';
import { LicenseLogFilterDetails } from '../components/LicenseLogFilters';
export const LicenseLogChart = ({
  filters,
}: {
  filters: LicenseLogFilterDetails;
}) => {
  const { chartData, error } = useLicenseStats(
    filters.granularity ?? 'minute',
    filters.dateRange[0],
    filters.dateRange[1],
    filters.app,
    filters.forceRefresh
  );

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const min =
    filters.dateRange[0] && filters.dateRange[1]
      ? filters.dateRange[0].toISOString() ?? undefined
      : undefined;
  const max =
    filters.dateRange[0] && filters.dateRange[1]
      ? filters.dateRange[1].toISOString() ?? undefined
      : undefined;

  return (
    <Box>
      {chartData ? (
        <Line
          data={chartData}
          options={{
            scales: {
              x: { type: 'time', time: { unit: 'minute' }, min, max },
              y: { min: 0 },
            },
            plugins: { colors: { enabled: true } },
          }}
        />
      ) : (
        <Loader />
      )}
    </Box>
  );
};
